
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOn as ObiOnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-on.js';
 
 
 

 
 export const ObiOn = createComponent({
   react: React,
   tagName: 'obi-on',
   elementClass: ObiOnElement,
   events: {
     
   }
  });
 
 